import Vue from 'vue';

Vue.use(VueI18n)

import VueI18n from 'vue-i18n';
//@ts-ignore
import en from './lang/en.json';
import moment from 'moment';

export const LANGUAGES = {
  en:{
    id: 'en',
    name: 'English'
  },
  es:{
    id: 'es',
    name: 'Español'
  },
  zh:{
    id: 'zh',
    name: '中文'
  },
  ru:{
    id: 'ru',
    name: 'Русский'
  }
};

const availableLanguages = ['en','es','zh','ru']

const messages = {
  en
}

const initialLanguage = ()=>{
  const navigatorLocale =
    navigator.languages !== undefined
      ? navigator.languages[0]
      : navigator.language
  if (!navigatorLocale) {
    return undefined
  }
  const browserLanguage  = navigatorLocale.trim().split(/-|_/)[0]

  const lang  = availableLanguages.includes(browserLanguage) ? browserLanguage  : 'en'

  if(lang==='en') return lang;

  import(/* webpackChunkName: "lang-[request]" */ `@/i18n/lang/${lang}.json`).then(
    messages => {
      i18n.setLocaleMessage(lang, messages.default)
      loadedLanguages.push(lang)
    }
  )
  return lang
}

interface ExtendedVueI18n extends VueI18n {
  vm?: Vue
}

const i18n:ExtendedVueI18n = new VueI18n({
  locale: initialLanguage(),
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  formatter: {
    interpolate(message, values, path) {
      if (message.lastIndexOf('{') !== -1) {
        message = message
          .replace(/{([^\\]*?)}/gmi, d => {
            const value = values[d[1]]
            if (value || value===0) return value
            return d
          })
          .replace(/\\{(.+?)\\}/gmi, '{$1}');
      }
      return [message];
    }
  },
  missing: function (lang,key,c) {
    if (process.env.VUE_APP_CONFIG_NAME !== 'production') {
      console.log(`missing i18n key: ${key}`);
    }

  },
  pluralizationRules: {
    /**
     * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
     * @param choicesLength {number} an overall amount of available choices
     * @returns a final choice index to select plural word by
     */
    'ru': function(choice, choicesLength) {
      //0 things | things count ends with 1 | things count ends with 2-4 | things count ends with 5-9, 0 and teens (10-19)

      // this === VueI18n instance, so the locale property also exists here

      if (choice === 0) {
        return 0;
      }

      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;

      if (choicesLength < 4) {
        return (!teen && endsWithOne) ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }

      return (choicesLength < 4) ? 2 : 3;
    }
  },
  messages
});

const loadedLanguages = ['en'] // our default language that is preloaded

function setI18nLanguage (lang) {
  i18n.locale = lang;
  moment.locale(lang==='zh' ? 'zh-cn' : lang);
  i18n.vm.$vuetify.lang.current = lang==='zh' ? 'zhHans' : lang;
  // axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export const loadLanguageAsync = (lang) => {
  let langToApply = lang;
  if(!availableLanguages.includes(langToApply)){
    langToApply = 'en'
  }

  // If the same language
  if (i18n.locale === langToApply) {
    return Promise.resolve(setI18nLanguage(langToApply))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(langToApply)) {
    return Promise.resolve(setI18nLanguage(langToApply))
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/i18n/lang/${langToApply}.json`).then(
    messages => {
      i18n.setLocaleMessage(langToApply, messages.default)
      loadedLanguages.push(langToApply)
      return setI18nLanguage(langToApply)
    }
  )
}


Vue.prototype.t = (key, opts) => {
  return i18n.t(String(key).toLowerCase(),{ ...opts }) || key;

  // return typeof value === 'string'
  //   ? i18n.tc(key, 1, { default: value, ...opts })
  //   : i18n.tc(key, 1, { ...value });
};
Vue.prototype.tc = (key, choice, opts) => {
  return i18n.tc('____plural.'+key, choice, { ...opts }) || key;
};

export default i18n;
